import { globalApiConfig } from '@/services/telehealthApi/APIConfig'
import { ConsultationSummaryReportApi, type ExportSummaryRequest } from '@/generated'

interface FileResponse {
  file: File
  fileName: string
}

export class ConsultationSummaryReportService {
  static readonly consultationSummaryReportApi = new ConsultationSummaryReportApi(globalApiConfig)

  static async exportConsultationsSummaryReport(body: ExportSummaryRequest): Promise<FileResponse> {
    const response =
      await ConsultationSummaryReportService.consultationSummaryReportApi.exportConsultationsSummaryReport(
        body,
        { responseType: 'arraybuffer' }
      )
    let fileName = 'file.pdf'

    const contentDisposition = response.headers['content-disposition']
    if (contentDisposition) {
      fileName = contentDisposition?.split('filename=')[1]
    }

    return {
      file: response.data,
      fileName
    }
  }
}
